import { render, staticRenderFns } from "./InformationTab.vue?vue&type=template&id=3985676f&scoped=true&"
import script from "./InformationTab.vue?vue&type=script&lang=js&"
export * from "./InformationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3985676f",
  null
  
)

/* custom blocks */
import block0 from "./InformationTab.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3985676f')) {
      api.createRecord('3985676f', component.options)
    } else {
      api.reload('3985676f', component.options)
    }
    module.hot.accept("./InformationTab.vue?vue&type=template&id=3985676f&scoped=true&", function () {
      api.rerender('3985676f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InformationTab/InformationTab.vue"
export default component.exports